// ** Reactstrap Imports
import { Col, Row } from "reactstrap";

// ** Custom Components
import FacebookPostsCard from "@components/cards/FacebookPostsCard";

// ** Styles
import "@styles/base/pages/page-blog.scss";

const FacebookPosts = ({ data, loading }) => {
  return (
    <Row>
      {data !== null &&
        data.length !== 0 &&
        data?.map((item, idx) => (
          <Col sm="12" md="6" lg="4" key={idx}>
            <FacebookPostsCard item={item} loading={loading} />
          </Col>
        ))}
    </Row>
  );
};
export default FacebookPosts;
